import api from './api'
import type { ApiResponse } from '../types'

// ================================================================================
// SYMPTOM CHECKER SERVICE — public, strictly non-diagnostic TB symptom checker.
// GET /symptom-checker/symptoms returns a localised symptom catalog; POST
// /symptom-checker/assess returns an advisory risk band + recommendation that
// directs the user towards testing/help. It NEVER diagnoses TB.
// ================================================================================

export interface Symptom {
  id: string
  label: string
  description?: string
  redFlag: boolean
}

export type SymptomRiskLevel = 'NONE' | 'LOW' | 'MODERATE' | 'URGENT'

export interface SymptomAction {
  label: string
  type: 'LINK' | 'CALL'
  /** Router path for LINK actions. */
  path?: string | null
  /** tel: href for CALL actions. */
  href?: string | null
}

export interface SymptomAssessment {
  riskLevel: SymptomRiskLevel
  riskLabel: string
  summary: string
  recommendation: string
  disclaimer: string
  selectedSymptoms: string[]
  actions: SymptomAction[]
}

/** Localised selectable symptom catalog. */
export async function getSymptoms(): Promise<Symptom[]> {
  const res = await api.get<ApiResponse<Symptom[]>>('/symptom-checker/symptoms')
  return res.data.data
}

/**
 * Submit the user's selected symptom ids and receive a non-diagnostic advisory
 * result. Empty array = nothing selected.
 */
export async function assessSymptoms(symptomIds: string[]): Promise<SymptomAssessment> {
  const res = await api.post<ApiResponse<SymptomAssessment>>('/symptom-checker/assess', { symptomIds })
  return res.data.data
}